import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import { CATEGORY_INFIX, EDITO_INFIX, PRODUCT_INFIX, STATIC_INFIX, SEARCH_INFIX } from '~/const/infix';
import { MERCURE_OPENING_STATUS } from '~/const/orders';

var buildHomeUrl = function buildHomeUrl() {
  return '/';
};

var CgvType = {
  PRO: 'cgv-pro',
  MARKETPLACE: 'cgv-marketplace',
  DEFAULT: 'cgv'
};

var buildCategoryUrl = function buildCategoryUrl(locale, slug, hash) {
  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(CATEGORY_INFIX, "/").concat(slug, "-").concat(hash);
};

var buildProductUrl = function buildProductUrl(locale, slug, reference) {
  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(PRODUCT_INFIX, "/").concat(slug, "-").concat(reference, ".htm");
};

var buildStaticUrl = function buildStaticUrl(locale, slug, oldVersion) {
  if (oldVersion) {
    // handle WEB static pages url until they switch to nuxt
    return "/".concat(locale.market, "/").concat(locale.language, "/").concat(slug);
  }

  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(STATIC_INFIX, "/").concat(slug);
};

var buildSearchUrl = function buildSearchUrl(locale, query) {
  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(SEARCH_INFIX, "/").concat(query);
};

var buildEditoUrl = function buildEditoUrl(locale, page) {
  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(EDITO_INFIX, "/").concat(page);
};

var buildMyAccountUrl = function buildMyAccountUrl(locale) {
  return "/".concat(locale.market, "/").concat(locale.language, "/user");
};

var buildFaqUrl = function buildFaqUrl(locale, page) {
  return "/".concat(locale.market, "/").concat(locale.language, "/help/faq/").concat(page);
};

var buildContactFormUrl = function buildContactFormUrl(locale, page) {
  return "/".concat(locale.market, "/").concat(locale.language, "/help/contact/").concat(page);
};

var buildReturnFormUrl = function buildReturnFormUrl(locale, page) {
  return "/".concat(locale.market, "/").concat(locale.language, "/help/return/").concat(page);
};

var buildCgvUrl = function buildCgvUrl(locale, page) {
  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(EDITO_INFIX, "/legale/").concat(CgvType[page] || CgvType.DEFAULT);
};

var buildCartUrl = function buildCartUrl(locale) {
  if (this.$cookies.get('MDM_TEST_MERCURE') || MERCURE_OPENING_STATUS[locale.iso]) {
    return "/".concat(locale.market, "/").concat(locale.language, "/cart");
  }

  return "/".concat(locale.market, "/").concat(locale.language, "/panier.html");
};

export var buildUrlForCheckout = {
  buildHomeUrl: buildHomeUrl,
  buildProductUrl: buildProductUrl,
  buildCartUrl: buildCartUrl,
  buildMyAccountUrl: buildMyAccountUrl,
  buildCgvUrl: buildCgvUrl
};
export default {
  methods: {
    buildCategoryUrl: buildCategoryUrl,
    buildEditoUrl: buildEditoUrl,
    buildProductUrl: buildProductUrl,
    buildStaticUrl: buildStaticUrl,
    buildSearchUrl: buildSearchUrl,
    buildFaqUrl: buildFaqUrl,
    buildContactFormUrl: buildContactFormUrl,
    buildReturnFormUrl: buildReturnFormUrl,
    buildCartUrl: buildCartUrl
  }
};